import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { customerVersionList } from "../../../redux/actions/customerActions";
import CustomerHistoryTableData from "./CustomerHistoryTableData";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import NumberPagination from "../../../components/Pagination/number-pagination";

const CustomerVesrionHistoryTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [customerVersionHistoryList, setCustomerVersionHistoryList] = useState(
    []
  );
  const [loading, setLoading] = useState(false);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(customerVersionList({ search, page }, onSuccess, onError));
  }, [search, page]);

  const onSuccess = (data) => {
    setLoading(false);
    setCustomerVersionHistoryList(data.data.data);
  };

  const onError = (err) => {
    setLoading(false);
  };

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table">
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"3%"}>
                  #
                </th>
                <th className="table-heads" width={"10%"}>
                  Jivini's Doctor Code
                </th>

                <th className="table-heads" width={"12%"}>
                  Doctor Name
                </th>
                <th className="table-heads" width={"12%"}>
                  Phone
                </th>
                <th className="table-heads" width={"8%"}>
                  Onboarding Type
                </th>
                <th className="table-heads" width={"10%"}>
                  Status
                </th>
                <th className="table-heads" width={"10%"}>
                  City
                </th>
                <th className="table-heads" width={"8%"}>
                  Manufacturer Name
                </th>
                <th className="table-heads" width={"12%"}>
                  Divisions
                </th>
                <th className="table-heads" width={"8%"}>
                  Updated By
                </th>
                <th className="table-heads" width={"12%"}>
                  Updated Date
                </th>
                <th className="table-heads" width={"10%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : customerVersionHistoryList?.data?.length > 0 ? (
                <>
                  {customerVersionHistoryList?.data?.map((eachRow, index) => (
                    <CustomerHistoryTableData
                      key={eachRow.id}
                      data={eachRow}
                      index={index}
                      currentPage={
                        customerVersionHistoryList?.pagination?.currentPage
                      }
                    />
                  ))}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {customerVersionHistoryList?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={customerVersionHistoryList?.pagination?.currentPage}
              totalPages={customerVersionHistoryList?.pagination?.totalPages}
              path={"/customers/onboarded-doctors/version-history"}
              filters={`${queryString}`}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default CustomerVesrionHistoryTable;
